<div *ngIf="loading" class="fullScreenLoading"></div>
<div class="container">
    
    <div class="">
        <p-toast></p-toast>
        <!-- <div class="background"></div> -->
        <div class="login-card">
            
            <div>
                <div>
                    <a>
                        <img src="{{imadataLogo}}" class="logo">
                    </a>
                </div>
                <p *ngIf="!loading" id="loading_page" style="opacity: 0;">success</p>
                <br>
                <form [formGroup]="aFormGroup" (ngSubmit)="login()" class="login-forms">
                    <input pInputText placeholder="user@email.com" formControlName="email" class="inputForm">
                    <p-password formControlName="password" [toggleMask]="true" [feedback]="false" class="inputForm-pass" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-password>
                    <ngx-recaptcha2 #captchaElem
                        [siteKey]="siteKey"
                        formControlName="recaptcha">
                    </ngx-recaptcha2>
                  <button pButton pRipple label="Login" class="p-button-success buttonForm"></button>
                  </form>
            </div>
        </div>
    </div>
</div>
